import { Component, Input, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Compiler, ViewChild, OnChanges, OnInit, SimpleChanges, Renderer2 } from '@angular/core';
import * as $ from 'jquery';

import { ProductService } from '../../services/product.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { ActivatedRoute } from '@angular/router';
declare var document: any;
declare var Swiper: any;
declare var window: any;
const componentList: Array<string> = ['footer', 'footerQuickLinkSection', 'mainNavigation', 'topNavigation','termsCondition'];

@Component({
  selector: 'app-view-cms-content',
  templateUrl: './view-cms-content.component.html',
  styleUrls: ['./view-cms-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ViewCmsContentComponent implements OnChanges {
  className: string;
  @Input() cmsContentUrl?: string;
  @Input() cmsContentId?: string;
  @Input() lastComponent?: string;
  @ViewChild('htmlContainer') container;
  trustedHTML: any;
  ENV: string;
  constructor(
    private productService: ProductService,
    private UTS: UtilitiesService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private R: Renderer2) {
    this.ENV = this.UTS.getENV();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cmsContentId']) {
      this.className = this.updateClass();
    }
    if (this.cmsContentUrl) {
      try {
        setTimeout(() => {
          this.productService
            .getCMSContent("/" + this.cmsContentUrl, 'GET')
            .subscribe((res: any) => {
              this.trustedHTML = this.sanitizer?.bypassSecurityTrustHtml(res.htmlSrc.toString());

            setTimeout(() => { //wait for DOM rendering
              let scripts = this.container?.nativeElement?.getElementsByTagName('script');
              for (let script of scripts) {
                if (script && script?.text) {
                  try {
                    eval(script?.text)
                  } catch (e) {
                    console.log(e)
                  }
                }
              }

              this.route.queryParams.subscribe((q) => {
                const env =this.UTS.getENV();
                const ispreprod = document.location.href.includes("uat.etisalat.ae");
                if (this.lastComponent == 'true') {
                  // if (!ispreprod) {
                    this.getHeaderLibs(AppSettings.HEADER_LIBS).then(res => {
                      this.getFooterLibs(AppSettings.FOOTER_LIBS)
                    })
                  // }
                }
              });

            }, 1000)
            this.cdr.detectChanges();
          }, (e) => {

            });
        }, 1500);
      }
      catch (e) {
        console.log(e)
      }
    } else {
      this.trustedHTML = '';
    }
  }

  private updateClass() {
    const isValid = componentList.includes(this.cmsContentId);
    return (isValid ? 'aem-spa-wrap' : '');
  }
  private updateQueryStringParam(value: string): string {
    const key = 'locale';
    var keyRegex = new RegExp(`([\?&])${key}[^&]*`);
    const baseUrl = `${location.protocol}//${location.host}${location.pathname}`;
    const urlQueryString = document.location.search;
    const newParam = `${key}=${value}`;
    if (urlQueryString) {
      if (urlQueryString.match(keyRegex) !== null)
        return `${baseUrl}${urlQueryString.replace(keyRegex, '$1' + newParam)}`;
      else return `${urlQueryString}&${newParam}`;
    }
    return `${baseUrl}${newParam}`;
  }

  async getHeaderLibs(headerUrl) {
    this.productService
      .getLibs("/" + headerUrl, 'GET')
      .subscribe((res: any) => {
        if (res?.htmlSrc) {
          this.loadScripts(res.htmlSrc, document.getElementById('headerLibs'), 'header');
        }

      }, (e) => {
        console.log("failed to retrive header libs");
      });
  }
  async getFooterLibs(footerUrl) {

    await this.productService
      .getLibs("/" + footerUrl, 'GET')
      .subscribe((res: any) => {
        if (res?.htmlSrc) {
          this.loadScripts(res.htmlSrc, document.getElementById('footerLibs'), 'footer')
        }
        setTimeout(() => {
          window && window.DYNAMIC_COMPONENTS && window.DYNAMIC_COMPONENTS.loadAll();
        }, 1500);
      }, (e) => {
        console.log("failed to retrive footer libs");
      }, () => {

      });

  }
  async loadScripts(htmlStr: string, targetEl: any, type: string) {
    let domParser = new DOMParser();
    const html = domParser.parseFromString(htmlStr, 'text/html');

    let length = (type == 'header') ? 1 : html?.scripts.length
    for (let index = 0; index < length; index++) {
      const script = html.scripts[index];
      let scriptTag = this.R.createElement('script');
      scriptTag.type = 'text/javascript';
      scriptTag.src = script.src;
      scriptTag.async = true; // makes script run asynchronously
      this.R.appendChild(targetEl, scriptTag);
    }
  }
}